"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LinksToTranslations;
const react_1 = __importDefault(require("react"));
const context_1 = __importDefault(require("../context"));
const react_intl_1 = require("react-intl");
const language_selector_1 = __importStar(require("~/components/language-selector/language-selector"));
function LinksToTranslations() {
    const { translations: [translations = []] } = (0, context_1.default)();
    const LinkPresentation = react_1.default.useCallback(({ locale }) => (react_1.default.createElement(AnotherLanguage, { locale: locale, translations: translations })), [translations]);
    if (translations.length === 0) {
        return null;
    }
    return (react_1.default.createElement(language_selector_1.default, { LeadIn: LeadIn, otherLocales: translations.map((t) => t.locale), LinkPresentation: LinkPresentation }));
}
function LeadIn() {
    return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'bookAvailableIn', defaultMessage: 'This book available in' }));
}
function AnotherLanguage({ locale, translations }) {
    const translation = react_1.default.useMemo(() => translations.find((t) => t.locale === locale), [translations, locale]);
    // translation is guaranteed to have a valid value, because the locale
    // is pulled from translations
    return (react_1.default.createElement("a", { href: `/details/books/${translation === null || translation === void 0 ? void 0 : translation.slug}` },
        react_1.default.createElement(language_selector_1.LanguageText, { locale: locale })));
}
